module.exports = __webpack_public_path__ + "static/media/dota4.06e8ac15.gif";